export default class scroll {
    constructor(manager, concept) {

        //manager
        this.manager = manager;
        this.conceptManager = concept;

    }
    renderIndex() {

        // if(this.manager.param.displayType != 'sp') return;
        this.num = this.manager.param.displayType === 'sp' ? 50 : 150

        if (this.num <= this.manager.scroll.nowInc) {
            if (this.conceptManager.status.titleFlg) return;
            this.conceptManager.status.titleFlg = true;
            TweenLite.to(this.conceptManager.$title, .6, {
                opacity: 0,
                y: -20,
                ease: Power2.easeOut,
            });
        } else {
            if (!this.conceptManager.status.titleFlg) return;
            this.conceptManager.status.titleFlg = false;
            TweenLite.to(this.conceptManager.$title, .6, {
                opacity: 1,
                y: 0,
                ease: Power2.easeOut,
            });
        }

    }
    renderDetail() {

        if (this.manager.param.displayType == 'sp' || (this.manager.isIpad && this.manager.portrait)) return;
        for (let i in this.conceptManager.status.point) {
            if(this.conceptManager.status.point[i]<=this.manager.scroll.nowInc){
                TweenLite.to(this.conceptManager.$photoList[i],1.2,{
                    opacity:1,
                    display:'block',
                    ease: Power2.easeOut,
                });
            }else{
                TweenLite.to(this.conceptManager.$photoList[i],1.2,{
                    opacity:0,
                    display:'none',
                    ease: Power2.easeOut,
                });
            }
        }

    }
    resizeIndex(){

        let _rect =  this.conceptManager.$linkList[0].getBoundingClientRect();
        this.conceptManager.status.titlePoint = (_rect.top + this.manager.scroll.nowInc) - 150;

    }
    resizeDetail(){

        let _point = document.body.clientHeight / this.conceptManager.$photoList.length;

        for(let i in this.conceptManager.$photoList){
            if(this.conceptManager.$photoList[i].nodeType!=1) break; // dom要素以外は処理止める

            this.conceptManager.status.point[i] = (_point * i) - window.innerHeight / 2;

        }

    }
}